'use strict';
(function() {

  var RelatedsComponent = {
    controller: RelatedsComponentCtrl,
    templateUrl: 'relateds.component.html',
    bindings: {
      place: '<',
      baseProduct: '<',
      excluded: '<',
      onRelatedCarrouselVisible: '&'
    }
  };

  angular.module('itxApp.common')
    .component('relatedsComponent', RelatedsComponent);

    RelatedsComponentCtrl.$inject = [
      'ProductRelatedSvc',
      'ItxShopCartFct',
      '$q',
      'ProductViewedCacheSvc',
      'productPopupSvc',
      'imProductService',
      'CountryService',
      'DUTTI_CONS',
      'ItxScreenSizeSvc',
      'ItxUtilsFct',
      'CatalogUrlService'
    ];

    function RelatedsComponentCtrl(
      ProductRelatedSvc,
      ItxShopCartFct,
      $q,
      ProductViewedCacheSvc,
      productPopupSvc,
      imProductService,
      CountryService,
      DUTTI_CONS,
      ItxScreenSizeSvc,
      ItxUtilsFct,
      CatalogUrlService
    )
    {
      var _this = this;
      _this.excludedProducts = [];
      _this.$onInit = function() {
        _this.isMobile = ItxScreenSizeSvc.isMobile();
        if(_this.excluded){
         _this.excludedProducts = angular.copy(_this.excluded);
        }
        if(_this.baseProduct) {
          _this.excludedProducts.push(_this.baseProduct);
        }
        if(_this.place){
          addCartProductsToExcluded()
          .then(() => {
            _this.amount = ProductRelatedSvc.getAmountFromPlace(_this.place);
            ProductRelatedSvc.getRelatedsCarrouselsToShow(_this.place)
            .then((carrousels) => {
              _this.carrousels = carrousels;
            });
          });
        }
      };

      _this.onProductClicked = function(product) {
        product = product.product;
        const selectedColorId = product.state.selectedColor.id;

        ProductViewedCacheSvc.addProduct(product.id, selectedColorId, null);
        imProductService.eventRelatedProductClick(product, product.typeRelated, inditex.iPage, null, _this.place);

        const action = ProductRelatedSvc.getFunctionFromPlace(_this.place);
        if(action === 'navigateToProduct'){
          if(_this.place === 'PRODUCT_GRID'){
            inditex.setSessionStorage('BACK_TO_GRID_PRODUCT_' + inditex.iCategoryId, JSON.stringify({id: product.id}) );
          }
          if (CountryService.is(DUTTI_CONS.country.CN) && !_this.isMobile) {
            window.open(product.getUrl(), '_blank');
          } else {
            window.location.href = product.getUrl();
          }
        } else if(action === 'changeProductView'){
          ItxUtilsFct.scrollTopProduct();
          CatalogUrlService.changeStateProduct(product);
        } else if(action === 'openPopup'){
          productPopupSvc.openProductPopup(product);
        }
    };

      function addCartProductsToExcluded() {
        var deferred = $q.defer();
  
        ItxShopCartFct.getCart()
        .then((shopCart) => {
          if(shopCart){
            const cartItems = shopCart.items;
            if(cartItems && cartItems.length > 0){
              _this.excludedProducts.push(cartItems);
            }
          }
        })
        .finally(() => deferred.resolve());
  
        return deferred.promise;
      }
    }

})();